export default "__VITE_ASSET__5fd7bd00__"